import _ from 'underscore';
import React, { useState, memo } from 'react';
import {
  domChildren as domChildrenProps,
  instumentationServiceContext as instumentationServiceContextProps,
} from '@bingads-webui-campaign-react/props-mca';
import { InstrumentationContext as HocInstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

export const InstrumentationContext = React.createContext([null, _.noop]);

export const InstrumentationContextProvider = memo((props) => {
  const {
    context,
    children,
  } = props;

  const [instrumentationService, setInstrumentationService] = useState(context);
  const { instrumentation = null } = instrumentationService || {};

  return (
    <InstrumentationContext.Provider value={[instrumentationService, setInstrumentationService]}>
      <HocInstrumentationContext.Provider value={instrumentation}>
        {children}
      </HocInstrumentationContext.Provider>
    </InstrumentationContext.Provider>
  );
});

InstrumentationContextProvider.propTypes = {
  context: instumentationServiceContextProps.isRequired,
  children: domChildrenProps.isRequired,
};
